import { Component } from '@angular/core';
import {ApiService} from './shared/api.service';
import {UserService} from './shared/user.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css']
})
export class AppComponent {
    progress = false;
    showLogin = true;
    constructor(private api: ApiService, private userService: UserService) {
        this.api.progress.subscribe(
            progress => {
                this.progress = progress;
            }
        );
        this.userService.user.subscribe(user => {
            if( user.id ) {
                this.showLogin = false;
            } else {
                this.showLogin = true;
            }
        });
    }
}